import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Search } from 'styled-icons/boxicons-regular';
import { Plus } from 'styled-icons/bootstrap';
import CustomUploadButton from 'react-firebase-file-uploader/lib/CustomUploadButton';
import uuid from 'uuid';
import dayjs from 'dayjs';
import DateFnsUtils from '@date-io/date-fns';
import BarLoader from 'react-spinners/BarLoader';
import { Add } from 'styled-icons/fluentui-system-regular';
import { ArrowBackIos } from 'styled-icons/material-outlined';
import Grid from '@material-ui/core/Grid';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { toast } from 'react-toastify';
import { palette } from '../../system/styles/styles';
import PostPreview from '../../components/blogs/modals/previewPost';
import ConfirmDelete from '../../components/blogs/modals/confirmDelete';
import { createNewPost, loadPosts } from '../../redux/actions/_news_actions';
import { firebase } from '../../model/firebase/firebase';
import PostsCard from '../../components/blogs/post/card';
import PostEditor from '../../components/blogs/post/postEditor';
import { MainDashboardSection } from '../../system/styles/views/blogs';

const MainDashboard = () => {
  const platform = useSelector((state) => state.platform);
  const posts = useSelector((state) => state.posts);

  const dispatch = useDispatch();

  const [newPost, setNewPost] = React.useState({
    postTitle: '',
    postSubTitle: '',
    Status: true,
    editBy: '',
    postDate: new Date(),
    expirationDate: dayjs().add(30, 'day'),
    postBody: '',
    category: '',
    cardSize: 'normal',
    likes: 0,
    views: 0,
    img: '',
    mode: '',
    tag: '',
    editorData: '',
    imageID: '',
    objectID: '',
    imageChangesOn: false,
    campusSegment: '',
  });
  const [state, setState] = React.useState({
    posts: [],
    add: true,
    edit: false,
    alert: false,
    message: '',
    severity: 'success',
    confirm: false,
    isUploading: false,
    showPreview: false,
  });
  const [deleteItem, setDeleteItem] = React.useState({});

  const handleChangeEditor = (html) => {
    setNewPost((prevState) => ({
      ...prevState,
      editorData: html,
    }));
  };

  const handleUploadStart = () => {
    setState((prevState) => ({ ...prevState, isUploading: true, progress: 0, imageChangesOn: true }));
  };

  const handleProgress = (progress) => setState((prevState) => ({ ...prevState, progress }));

  const handleUploadError = () => {
    setState((prevState) => ({ ...prevState, isUploading: false }));
  };

  const handleUploadSuccess = async (file) => {
    setState((prevState) => ({ ...prevState, progress: 100, isUploading: false }));
    const url = await firebase.storage().ref(`platforms/${platform.platformName}/posts/`).child(file).getDownloadURL();
    setNewPost((prevState) => ({
      ...prevState,
      imageID: file,
      img: url,
    }));
  };

  const changeDate = (date) => {
    setNewPost((prevState) => ({
      ...prevState,
      expirationDate: date,
    }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewPost((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // const changeSize = (size) =>
  //   setNewPost((prevState) => ({
  //     ...prevState,
  //     cardSize: size,
  //   }));

  const handleSubmit = async (action) => {
    if (
      newPost.img !== '' &&
      newPost.postTitle !== '' &&
      newPost.editorData !== '' &&
      newPost.expirationDate !== '' &&
      newPost.category !== ''
    ) {
      await dispatch(createNewPost(newPost, state.edit, action));
      setState((prevState) => ({
        ...prevState,
        add: true,
        message: 'Se guardó de manera correcta',
        severity: 'success',
        alert: true,
        edit: false,
      }));
      toast.success('Se guardó de manera correcta');
      setNewPost((prevState) => ({
        ...prevState,
        postTitle: '',
        postSubTitle: '',
        Status: true,
        editBy: '',
        postDate: new Date(),
        expirationDate: new Date(),
        postBody: '',
        category: '',
        cardSize: '',
        likes: 0,
        views: 0,
        img: '',
        mode: '',
        tag: '',
        editorData: '',
        imageID: '',
      }));
    } else {
      setState((prevState) => ({
        ...prevState,
        message: 'Debes de completar todos los campos',
        severity: 'warning',
        alert: true,
      }));
      toast.warning('Debes de completar todos los campos');
    }
  };

  const searchType = (e) => {
    const { value } = e.target;
    const postsFilter = posts
      .filter((post) => {
        const postTitle = post.postTitle.toLowerCase().includes(value.toLowerCase());
        const editorData = post.editorData.includes(value);
        const postSub = post.postSubTitle.toLowerCase().includes(value.toLowerCase());
        const postCategory = post.category.toLowerCase().includes(value.toLowerCase());
        return postTitle || editorData || postSub || postCategory;
      })
      .sort((a, b) => {
        return a.names < b.names;
      });
    setState((prevState) => ({
      ...prevState,
      posts: postsFilter,
    }));
  };

  const editPost = (data) => {
    const date = dayjs(data.expirationDate.seconds * 1000).toDate();
    // eslint-disable-next-line no-use-before-define
    if (isValidDate(date)) {
      setState((prevState) => ({
        ...prevState,
        edit: true,
        add: false,
      }));
      setNewPost((prevState) => ({
        ...prevState,
        ...data,
        expirationDate: date,
      }));
    } else {
      const date = data.expirationDate;
      setState((prevState) => ({
        ...prevState,
        edit: true,
        add: false,
      }));
      setNewPost((prevState) => ({
        ...prevState,
        ...data,
        expirationDate: date,
      }));
    }
  };

  const cancelAction = () => {
    setState((prevState) => ({ ...prevState, add: true, edit: false }));
    setNewPost((prevState) => ({
      ...prevState,
      postTitle: '',
      postSubTitle: '',
      Status: true,
      editBy: '',
      postDate: new Date(),
      expirationDate: '',
      postBody: '',
      category: '',
      cardSize: '',
      likes: 0,
      views: 0,
      img: '',
      draft: false,
      mode: '',
      tag: '',
      editorData: '',
      imageID: '',
    }));
  };

  const handleDelete = (data) => {
    setDeleteItem({ ...data });
    setState((prevState) => ({
      ...prevState,
      confirm: true,
    }));
  };

  const cancelDelete = () => {
    setDeleteItem({});
    setState((prevState) => ({
      ...prevState,
      confirm: false,
    }));
  };

  const isValidDate = (d) => {
    // eslint-disable-next-line no-restricted-globals
    return d instanceof Date && !isNaN(d);
  };

  React.useEffect(() => {
    dispatch(loadPosts());
  }, []);
  React.useEffect(() => {
    if (posts) {
      setState((prevState) => ({
        ...prevState,
        posts: [...posts],
      }));
    }
  }, [posts]);

  return (
    <MainDashboardSection adminColor={platform?.adminColor}>
      {state.add ? (
        <div className="postsContainer">
          <div className="actionsNav">
            <div className="leftNav">
              <h1>Noticias</h1>
              <div className="searchContainer">
                <Search className="searchIcon" size={20} />
                <input className="searchInput" type="text" placeholder="Buscar..." onChange={searchType} />
              </div>
            </div>
            <div className="rightNav">
              <div className="createNew">
                <p>Crear nuevo</p>
                <button
                  type="button"
                  onClick={() => setState((prevState) => ({ ...prevState, add: false, edit: false }))}>
                  <Add size={20} color="#fff" />
                </button>
              </div>
            </div>
          </div>
          <div className="divider">
            <p className="dividerText">Noticias activas</p>
            <p className="dividerLine" />
          </div>
          <Grid container spacing={1}>
            {/* eslint-disable-next-line array-callback-return,consistent-return */}
            {state.posts.map((i, ind) => {
              if (!i.draft) {
                return <PostsCard data={i} key={ind.toString()} activeEdit={editPost} activeDelete={handleDelete} />;
              }
            })}
          </Grid>
          <div className="divider">
            <p className="dividerText">Borradores</p>
            <p className="dividerLine" />
          </div>
          <div className="cardsContainer">
            {/* eslint-disable-next-line array-callback-return,consistent-return */}
            {state.posts.map((i, ind) => {
              if (i.draft) {
                return <PostsCard data={i} key={ind?.toString()} activeEdit={editPost} activeDelete={handleDelete} />;
              }
            })}
          </div>
        </div>
      ) : (
        <section className="editorContainer">
          <div className="editor">
            <Grid container className="editor-head" style={{ padding: '16px', borderBottom: 'solid 1px #EDECEF' }}>
              <Grid lg={2}>
                <button type="button" onClick={cancelAction} className="cancelButton">
                  <ArrowBackIos size={16} />
                </button>
              </Grid>
              <Grid lg={6} />
              <Grid item lg={4}>
                <div className="buttons-grid">
                  <button type="button" className="saveButtons-save" onClick={() => handleSubmit(true)}>
                    Guardar borrador
                  </button>
                  <button type="button" className="saveButtons-sub" onClick={() => handleSubmit(false)}>
                    Publicar
                  </button>
                </div>
              </Grid>
            </Grid>
            <Grid container style={{ padding: '16px 32px' }} spacing={4}>
              <Grid item lg={8}>
                <label className="editorLabel">
                  Redactar noticia <span className="requiredField">*</span>
                </label>
                <PostEditor
                  handleChange={handleChangeEditor}
                  html={newPost.editorData}
                  placeholder="Redacta tu noticia ..."
                />
              </Grid>
              <Grid lg={4}>
                <div
                  className="imageBox"
                  style={{
                    backgroundImage: newPost.img === '' ? 'white' : `url(${newPost.img})`,
                    backgroundPosition: 'center',
                    backgroundSize: 'cover',
                  }}>
                  {newPost.img === '' && !state.isUploading ? <Plus size={30} /> : null}
                  {state.isUploading ? <BarLoader sizeUnit="px" size={750} color={palette.blue} /> : null}
                </div>
                <CustomUploadButton
                  accept="image/*"
                  filename={uuid.v4()}
                  storageRef={firebase.storage().ref(`platforms/${platform.platformName}/`).child('posts')}
                  onUploadStart={handleUploadStart}
                  onUploadError={handleUploadError}
                  onUploadSuccess={handleUploadSuccess}
                  onProgress={handleProgress}
                  className="uploadImage">
                  <p className="editImageButton">
                    Agregar imagen
                    <span className="requiredField">*</span>
                  </p>
                </CustomUploadButton>
                <label className="editorLabel">
                  Título
                  <span className="requiredField">*</span>
                </label>
                <TextField
                  className="editorInput"
                  type="text"
                  onChange={handleInputChange}
                  name="postTitle"
                  value={newPost.postTitle}
                  required
                  variant="outlined"
                />
                <label className="editorLabel">Subtítulo</label>
                <TextField
                  className="editorInput"
                  type="text"
                  onChange={handleInputChange}
                  name="postSubTitle"
                  value={newPost.postSubTitle}
                  variant="outlined"
                />
                <div className="inputGroup">
                  <div className="inputGroup50">
                    <label className="editorLabel">
                      Tipo <span className="requiredField">*</span>
                    </label>
                    <Select
                      className="editorInput"
                      onChange={handleInputChange}
                      name="category"
                      value={newPost.category}
                      variant="outlined"
                      required>
                      <MenuItem value="" hidden defaultChecked disabled>
                        Seleccionar
                      </MenuItem>
                      <MenuItem value="webinar">Webinar</MenuItem>
                      <MenuItem value="news">Noticia</MenuItem>
                      <MenuItem value="event">Evento</MenuItem>
                    </Select>
                  </div>
                  <div>
                    <label className="editorLabel">
                      Fecha de expiración <span className="requiredField">*</span>
                    </label>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        disableToolbar
                        variant="inline"
                        inputVariant="outlined"
                        disablePast
                        className="time"
                        format="dd/MM/yyyy"
                        margin="normal"
                        id="date-picker-inline"
                        value={newPost.expirationDate}
                        onChange={changeDate}
                        KeyboardButtonProps={{
                          'aria-label': 'change date',
                        }}
                      />
                    </MuiPickersUtilsProvider>
                  </div>
                  <div className="inputGroup50">
                    <label className="editorLabel">Campus</label>
                    <Select
                      className="editorInput"
                      value={newPost.campusSegment}
                      onChange={handleInputChange}
                      variant="outlined"
                      name="campusSegment">
                      <MenuItem value="" hidden defaultChecked disabled>
                        Seleccionar campus
                      </MenuItem>
                      <MenuItem value="all">Todos</MenuItem>
                      {platform.platformCampus.map((i, ind) => {
                        return (
                          <MenuItem value={i} key={ind?.toString()}>
                            {i}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </div>
                  <div>
                    <label className="editorLabel">Autor</label>
                    <TextField
                      className="editorInput"
                      type="text"
                      onChange={handleInputChange}
                      name="editBy"
                      value={newPost.editBy}
                      variant="outlined"
                    />
                  </div>
                </div>
                <label className="editorLabel">Descripción</label>
                <TextField
                  rows={3}
                  className="editorTextarea"
                  onChange={handleInputChange}
                  name="postBody"
                  value={newPost.postBody}
                  required
                  variant="outlined"
                />
              </Grid>
            </Grid>
          </div>
        </section>
      )}
      <ConfirmDelete open={state.confirm} data={deleteItem} handleOpen={setState} CancelDelete={cancelDelete} />
      <PostPreview open={state.showPreview} data={newPost} handleClose={setState} />
    </MainDashboardSection>
  );
};

export default MainDashboard;
